<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Features
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <!-- Actions -->
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <BaseDataTable :data="features">
                <template #header>
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Feature
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Permissions
                    </th>
                    <th
                      scope="col"
                      class="relative py-3.5 pl-3 pr-4 sm:pr-6 text-sm font-semibold text-gray-900"
                    >
                      Options
                    </th>
                  </tr>
                </template>
                <template #default="{ item }">
                  <FeatureTableRow :feature="item" />
                </template>
              </BaseDataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { featuresClient } from '@/api/clients/admin';
import FeatureTableRow from './components/FeatureTableRow.vue';

export default {
  components: {
    FeatureTableRow,
  },
  data() {
    return {
      features: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      featuresClient
        .list({
          include: 'options,permissions',
        })
        .then((response) => {
          this.features = response.data;
        });
    },
  },
};
</script>
